export default "__VITE_ASSET__DDdeoNhH__"